export enum StorageType {
    MinIO = 1,
    AWS,
    Azure
  }
  